import $ from 'jquery';
import { _GLOBALS, _ALLOWED_MINTS, _TOKENS_REFERRAL_PROGRAM } from './globals.js';
import { Modal } from 'bootstrap';
import { loadingOverlay, Modals, Toasts } from './Helper.js';

import { detectWallets } from './ak_js_stuff/detectWallet.js';
import { detectTokens } from './ak_js_stuff/detectTokens.js';
import { connectWallet } from './ak_js_stuff/useWallet.js';
import { walletEvents } from './ak_js_stuff/walletEvents.js';
import { linkGen } from './linkGen/linkModule.js';
import { logit } from './ak_js_stuff/simpleLog.js';
import 'toolcool-range-slider/dist/plugins/tcrs-themes.min.css';
import 'toolcool-range-slider';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion, faCopy } from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion, faCopy);

// Automatically replace <i> tags with SVG
dom.watch();

let _PUBKEY = null;
let _WALLETS = null;
let _SELECTED_WALLET = null;
let _AVAILABLE_TOKENS = null;
let _SELECTED_REF_TOKEN = null;
let _SELECTED_REF_PCT = 5;
let _SELECTED_REFGROUP_TOKEN = null;
let _SELECTED_REFGROUP_PCT = 5;
let _ICONS_BASE_PATH = '/images/icons/';
let data = null;

let modalElement = null;
let modalInstance = null;

const _PAGE_ID = 'referralConfigView';

export const view = async(data = null) => {
    let selectedWallet = data.wallet;
    _SELECTED_WALLET = data.wallet;
    _PUBKEY = data.pubkey;
    _AVAILABLE_TOKENS = await detectTokens(null, _PUBKEY, _ALLOWED_MINTS);
    if (_GLOBALS.DebugMode)
        console.log("_AVAILABLE_TOKENS", _AVAILABLE_TOKENS);
    //_AVAILABLE_TOKENS = [];

    let connectedAddress = _PUBKEY.substr(0, 4) + '...' + _PUBKEY.substr(-4);
    let connectedStateBtn = `
        <button class="icon-link icon-link-hover btn-rounded btn-primary btn mb-3" href="#" onclick="Router.To('walletSelection');">
            <img src="${_ICONS_BASE_PATH}${selectedWallet.icon}" class="img-fluid round-border" width="25"/>
            ${connectedAddress}
        </button>
    `;

    _SELECTED_REFGROUP_TOKEN = _TOKENS_REFERRAL_PROGRAM.find((token) => token.symbol.toUpperCase() === "EQUI");
    // If USDC is not available take the first in the list
    if (!_SELECTED_REFGROUP_TOKEN) {
        _SELECTED_REFGROUP_TOKEN = _TOKENS_REFERRAL_PROGRAM[0];
    }

    _SELECTED_REF_TOKEN = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === "USDC");
    const UsdcToken = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === "USDC") || null;
    const UsdtToken = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === "USDT") || null;
    // If USDC is not available take the first in the list
    if (!_SELECTED_REF_TOKEN) {
        _SELECTED_REF_TOKEN = _AVAILABLE_TOKENS[0];
    }

    let stableCoins = '';
    if(UsdcToken) stableCoins += `<img src="${UsdcToken.logo}" width="25" class="me-2" />`;
    if(UsdtToken) stableCoins += `<img src="${UsdtToken.logo}" width="25" />`;

    let html = `
        <div id="${_PAGE_ID}" class="page-view transition-right">
            <div class="row">
                <div class="col-6">
                    <button class="icon-link icon-link-hover btn-rounded btn-primary btn mb-3" href="#" onclick="Router.To('walletSelection');">
                        <i class="fa-solid fa-chevron-left"></i>
                        Change Wallet
                    </button>
                </div>
                <div class="col-6 text-end connected_state_button">
                    ${connectedStateBtn}
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <p class="fs-3">Referral Manager</p>
                    <p>Decide if you want to distribute more bonus to your referral group or to yourself. You will receive payment in stablecoins (USDC or USDT) based on the percentage you select for each purchase made by your referrals.</p>
                </div>
            </div>
            <div class="row g-1">            
                <div class="col-6">
                    <div class="text-center round-border ref-group-box p-3 fillLvl5">
                        <p>My Referrals</p>
                        <p class="ms-auto px-2 py-1 refgroup-token-selector token_selector" onclick="showRefGroupTokenSelectionModal()">
                            <img src="${_SELECTED_REFGROUP_TOKEN.logo}" class="token_image" width="20"/>
                            <span class="symbol">${_SELECTED_REFGROUP_TOKEN.symbol}</span>
                            <i class="fa-solid fa-chevron-down"></i>
                        </p>
                        <p class="slider_min_value fs-1 text-white">${_SELECTED_REFGROUP_PCT}%</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="text-center round-border ref-box p-3 fillLvl5">
                        <p>Myself</p>
                        <p class="ms-auto px-2 py-1 ">
                            ${stableCoins}
                        </p>
                        <p class="slider_max_value fs-1 text-white">${_SELECTED_REF_PCT}%</p>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-1"></div>
                <div class="col-10">
                    <div class="bg-lighter round-border py-3">
                     <tc-range-slider
                        id="distributionSlider"
                        value1="5"
                        theme="circle"
                        slider-bg="#46bdcb"
                        slider-bg-fill="#bc44ee" 
                        pointer-width="30px"
                        pointer-height="30px"
                        slider-width="100%"></tc-range-slider>
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="text-center">
                        <button type="button" class="btn btn-pay btn-lg" id="generateLink" onclick="generateLink()">Generate link</button>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12" id="generatedLinkList">
                    
                </div>
            </div>
        </div>
    `;
    return html;
}

export const init = async () => {
    $(document).ready(() => {
        registerEvents();
        modalElement = document.getElementById('modal');
        modalInstance = new Modal(modalElement);
    });
}

const showRefTokenSelectionModal = () => {
    showTokenSelectionModal(_AVAILABLE_TOKENS, 'ref');
};
window.showRefTokenSelectionModal = showRefTokenSelectionModal;

const showRefGroupTokenSelectionModal = () => {
    showTokenSelectionModal(_TOKENS_REFERRAL_PROGRAM, 'refgroup');
};
window.showRefGroupTokenSelectionModal = showRefGroupTokenSelectionModal;

const showTokenSelectionModal = (tokenArray = [], type = 'ref') => {
    let tokenList = `<ul class="list-group" id="tokenList">`;
    tokenArray.forEach((token) => {
        tokenList += `
            <a href="#" class="list-group-item list-group-item-action" aria-current="true" data-token="${token.symbol}" onclick="selectToken('${token.symbol}', '${type}');">
                <img src="${token.logo}" class="token_image img-fluid my-2" width="50" onerror="this.src='${_ICONS_BASE_PATH}unkown.svg';"/>${token.name}
            </a>
        `;
    });
    tokenList += '</ul>';
    $(modalElement).find('.modal-body').empty().append(tokenList);

    modalInstance.toggle();
}
const selectToken = (tokenSymbol = '', type = 'buy') => {
    modalInstance.toggle();

    let token = null;
    if (type === "ref") {
        token = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === tokenSymbol);
        _SELECTED_REF_TOKEN = token;
        const span = `<img src="${token.logo}" width="20"/>&nbsp;${token.symbol}&nbsp;<i class="fa-solid fa-chevron-down"></i>`;
        $('.ref-token-selector').html(span);
    }
    if (type === "refgroup") {
        token = _TOKENS_REFERRAL_PROGRAM.find((token) => token.symbol.toUpperCase() === tokenSymbol);
        _SELECTED_REFGROUP_TOKEN = token;
        const span = `<img src="${token.logo}" width="20"/>&nbsp;${token.symbol}&nbsp;<i class="fa-solid fa-chevron-down"></i>`;
        $('.refgroup-token-selector').html(span);
}
}
window.selectToken = selectToken;

const generateLink = () => {
    //linkGen(kickBackAddr, referrals, myself, symbol)
    const url = linkGen(_PUBKEY, _SELECTED_REFGROUP_PCT, _SELECTED_REF_PCT, _SELECTED_REFGROUP_TOKEN.symbol);
    let html = `<div class="bg-lighter mb-2 round-border input-group">    
                    <input type="text" class="form-control form-input" value="${_GLOBALS.BaseUrl}?ref=${url}" placeholder="Click on generate link" disabled/> 
                    <button class="btn btn-outline-secondary copy_to_clipboard" type="button">
                        <i class="fa-solid fa-copy"></i>
                    </button>
                </div>`;

    $('#generatedLinkList').append(html);
}
window.generateLink = generateLink;

const registerEvents = () => {
    $('body').on('click', '.copy_to_clipboard', (e) => {
        const input = $(e.currentTarget).parent().find('.form-input');
        copyToClipboard(input[0]);
    });
    
    const slider = document.getElementById('distributionSlider');
        slider.theme = "circle";
        slider.min = "0";
        slider.max = "10";
        slider.value1 = "5";
        slider.step = "1";
        slider.height="1.2rem";

    slider.addEventListener('change', (evt) => {
        const value = evt.detail.value;

        _SELECTED_REF_PCT = value;
        _SELECTED_REFGROUP_PCT = 10 - value;

        $('.ref-group-box')
                .removeClass('fillLvl0 fillLvl1 fillLvl2 fillLvl3 fillLvl4 fillLvl5 fillLvl6 fillLvl7 fillLvl8 fillLvl9 fillLvl10')
                .addClass('fillLvl'+_SELECTED_REFGROUP_PCT);
        $('.ref-box')
                .removeClass('fillLvl0 fillLvl1 fillLvl2 fillLvl3 fillLvl4 fillLvl5 fillLvl6 fillLvl7 fillLvl8 fillLvl9 fillLvl10')
                .addClass('fillLvl'+_SELECTED_REF_PCT);

        $('.slider_min_value').html(`${_SELECTED_REFGROUP_PCT}%`);
        $('.slider_max_value').html(`${_SELECTED_REF_PCT}%`);
    });
}

const  copyToClipboard = async(inputElement) => {

    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(inputElement.value);
        return;
    }

    navigator.clipboard.writeText(inputElement.value).then(function () {
        Toasts.Success.Show('Copied');
    }, function (err) {
        Toasts.Error.Show('Error');
    });

    // Optionally deselect the input
    window.getSelection().removeAllRanges();
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        Toasts.Success.Show('Copied');
    } catch (err) {
        Toasts.Error.Show('Error');
    }

    document.body.removeChild(textArea);
}